export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["CREATED"] = "created";
    // while is processing transaction
    TransactionStatus["PROCESSING"] = "processing";
    // when transaction is pending to be signed
    TransactionStatus["PENDING_SIGNATURE"] = "pending_signature";
    // when transaction is signed but pending submission (sign-only flow)
    TransactionStatus["PENDING_SUBMISSION"] = "pending_submission";
    // after transaction has been broadcasted
    TransactionStatus["BROADCASTED"] = "broadcasted";
    // after transaction has succeeded
    TransactionStatus["SUCCEEDED"] = "succeeded";
    // after transaction has failed
    TransactionStatus["FAILED"] = "failed";
    // after transaction has been cancelled
    // TODO : is it needed? & needs to be handled in the flows
    TransactionStatus["CANCELLED"] = "cancelled";
    // after transaction has expired
    // TODO : is it needed? & needs to be handled in the flows
    TransactionStatus["EXPIRED"] = "expired";
})(TransactionStatus || (TransactionStatus = {}));
//# sourceMappingURL=transaction-status.enum.js.map